// extracted by mini-css-extract-plugin
module.exports = {"centered":"Error_centered__th3R2","signed":"Error_signed__5Ulp3"};